"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Storage", {
  enumerable: true,
  get: function get() {
    return _storage["default"];
  }
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _storage = _interopRequireDefault(require("./storage"));
var _consts = require("./utils/consts");
// Default expiration is 10 minutes.
var DEFAULT_EXPIRATION_MINUTES = 10;
var DEFAULT_SESSION_CACHE_EXPIRES = 7; // Days
var localCacheExpires = DEFAULT_EXPIRATION_MINUTES * _consts.MILLIS_IN_MINUTE;
var sessionCacheExpires = DEFAULT_SESSION_CACHE_EXPIRES * _consts.HOURS_IN_DAY * _consts.MINUTES_IN_HOUR * _consts.MILLIS_IN_MINUTE;

/*
 *  LocalCache expires in 10 minutes
 * TODO Not sure which sharedNameSpace needed for react sk just keep as it is
 */
var sharedNamespaces = ['global', 'app', 'page', 'mediator', 'model', 'collection'];
var namespaces = [];
var cacheNs = 'cache:';
var DEFAULT_CACHE = {
  expires: localCacheExpires,
  type: 'local',
  namespace: ''
};
var LegacyCache = /*#__PURE__*/function () {
  function LegacyCache(props) {
    (0, _classCallCheck2["default"])(this, LegacyCache);
    this.init(props);
  }
  (0, _createClass2["default"])(LegacyCache, [{
    key: "init",
    value: function init() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = props;
      this.getSetOptions(DEFAULT_CACHE, ['expires', 'type', 'namespace'], options, this);
      if (options.type === 'session' && !options.expires) {
        // For a session, let's set the expiration to a week
        this.expires = sessionCacheExpires;
      }
      if (!this.expires && this.expires !== 0 || !this.type || !this.namespace) {
        this.invalid = true;
        return;
      }
      if (namespaces.indexOf(this.namespace) > -1 && !sharedNamespaces.indexOf(this.namespace) > -1) {
        this.invalid = true;
        return;
      }
      if (namespaces.indexOf(this.namespace) > -1) {
        namespaces.push(this.namespace);
      }

      // Prevent any changes to cache instance properties
      if (typeof Object.freeze === 'function') {
        Object.freeze(this);
      }
    }
  }, {
    key: "set",
    value: function set(key, data) {
      // Set `data`, given a key `key`
      if (this.invalid) {
        return;
      }
      if (!data || !key) {
        return;
      }
      _storage["default"].setItem(this._cacheKey(key), data, this.type, this.expires);
    }

    // Internal method to define a cache namespace
  }, {
    key: "_cacheNamespace",
    value: function _cacheNamespace() {
      return "".concat(cacheNs + this.type, ":").concat(this.namespace, ":");
    }
    // Internal method to define a cache key
  }, {
    key: "_cacheKey",
    value: function _cacheKey(key) {
      return this._cacheNamespace() + key;
    }

    // Get `data`, given a key `key`
  }, {
    key: "get",
    value: function get(key) {
      return _storage["default"].getItem(this._cacheKey(key), this.type);
    }

    // Remove data for a given `key`
  }, {
    key: "remove",
    value: function remove(key) {
      _storage["default"].removeItem(this._cacheKey(key), this.type);
    }
  }, {
    key: "clear",
    value: function clear() {
      _storage["default"].clearNamespaced(this._cacheNamespace(), this.type);
    }

    /*
     * Release a cache by clearing all associated data and removing
     * its namespace from the internal array of namespaces
     */
  }, {
    key: "release",
    value: function release() {
      this.clear();
      this.unlockNamespace();
    }

    // Allow others to write to and read from the cache's namespace
  }, {
    key: "unlockNamespace",
    value: function unlockNamespace() {
      var _this = this;
      namespaces = namespaces.filter(function (value) {
        return value !== _this.namespace;
      });
    }
  }, {
    key: "getOption",
    value: function getOption(target, optionName, options) {
      if (!target || !optionName) {
        return;
      }
      var value;
      options = options || target.options;
      if (options && optionName in options && options[optionName] !== undefined) {
        value = options[optionName];
      } else {
        value = target[optionName];
      }
      return value;
    }

    /*
     * Shortcut method to get and set multiple options at once
     * `optionNames` is an array of options to set
     */
  }, {
    key: "getSetOptions",
    value: function getSetOptions(target, optionNames, options, context) {
      var _this2 = this;
      var that = context || this;
      this.toArray(optionNames).forEach(function (optionName) {
        var optionValue = _this2.getOption(target, optionName, options);
        if (typeof optionValue !== 'undefined') {
          that[optionName] = optionValue;
        }
      });
    }

    /*
     * Basic method to return a simple array with an object if
     * that object is not an array yet (Mostly useful for APIs
     * that return either an array in case of multiple result
     * items or a simple object in case of one result item).
     * This can't be used to turn `arguments` into an array.
     */
  }, {
    key: "toArray",
    value: function toArray(obj) {
      var out = Array.isArray(obj) ? obj : [obj];
      return out;
    }
  }]);
  return LegacyCache;
}();
var _default = LegacyCache;
exports["default"] = _default;